import { useEffect, useState } from "react";
import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";

function SemiannuallyDefectRateRateKpi (props){

    const table = "VwDefectRateHalfYearly";
    const view = "VwDefectRateHalfYearly";

    const { filterValue, onFilterInitialized, onSearchInitialized, onModifyViewSchema } = props;

    const [ api, setApi ] = useState ( null );

    useEffect ( () => {

        if ( api ) {

            api.refresh ();

        }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ api ] );


    const onApiInitialized = ( api ) => {

        setApi ( api );

    };

    return (
    
        
        <BasicCrudScreenType
            id="SemiannuallyDefectRateRateKpi"
            noHeader
            table={table}
            view={view}
            extFilterValue={filterValue}
            onFilterInitialized={onFilterInitialized}
            onModifyViewSchema={onModifyViewSchema}
            onSearchInitialized={onSearchInitialized}
            onApiInitialized={onApiInitialized}
        />

    );

}
export default SemiannuallyDefectRateRateKpi;